import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import i18next from 'i18next'
import { getStore } from '../store/storeRef'

const swal = withReactContent(Swal)
const t = (key) => i18next.t(key)

export const showErrorMessage = (res) => {
	if (Swal.isVisible()) return
	let message = res ? (res.error ? res.error : JSON.stringify(res.error)) : {}

	message =
		typeof message != 'string'
			? t('Ha ocurrido un error. Favor de contactar el administrador del sistema.')
			: message

	// WARNING(erandi, 13/03/2026):
	// Se compara el texto del mensaje de error contra un string en español para decidir
	// qué diálogo Swal mostrar. Si el mensaje del backend cambia o se traduce, esta
	// lógica se rompe. La lógica no debe depender directamente de los textos visuales.


	// Eliminar solo Log ID entre paréntesis
	message = message.replace(/\s*\(Log ID:[^)]*\)\s*$/gi, '')

	if (message.includes(t('Vinculación con Wialon no válida o expirada'))) {
		const state = getStore()?.getState()
		const wialonEnabled = state?.app?.user?.use_wialon_connection === true

		if (wialonEnabled) {
			Swal.fire({
				title: t('¡Advertencia!'),
				icon: 'error',
				showCloseButton: true,
				html: `
    <div style="text-align: left; font-size: 14px; color: #444;">
      <p style="margin-bottom: 14px; font-weight: 500;">
        ${t('La vinculación con')} <strong>Wialon</strong> ${t('no es válida o ha expirado.')}
      </p>
      <p style="margin-bottom: 10px; color: #666;">
        ${t('Esto puede deberse a:')}
      </p>
      <ul style="margin: 12px 0; padding-left: 18px;">
        <li style="margin-bottom: 12px;">
          <strong>${t('Contraseña cambiada:')}</strong>
          <a href="/wialon_connection" style="color: #0d6efd; text-decoration: none; font-weight: 500;">
            ${t('Actualizar credenciales')} →
          </a>
        </li>
        <li>
          <strong>${t('Servicio no disponible:')}</strong>
          <a href="https://status.wialon.com" target="_blank" style="color: #0d6efd; text-decoration: none; font-weight: 500;">
            ${t('Ver estado del servicio')} →
          </a>
        </li>
      </ul>
    </div>
  `,
				showCancelButton: true,
				showConfirmButton: false,
				cancelButtonText: t('Cerrar'),
				buttonsStyling: true,
				customClass: {
					popup: 'swal2-rounded swal2-shadow'
				}
			});
			return;
		}
		return;
	}

	swal
		.fire({
			title: t('¡Advertencia!'),
			text: message,
			icon: 'error',
			showCancelButton: true,
			cancelButtonText: t('Cerrar'),
			showCloseButton: true
		})
		.then((result) => {
			if (result.dismiss === swal.DismissReason.cancel) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.close) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.backdrop) {
				swal.close()
			}
		})

}

export const showSuccessMessage = (res) => {
	const message =
		typeof res != 'string'
			? t('Ha ocurrido un error. Favor de contactar el administrador del sistema.')
			: res

	swal
		.fire({
			title: t('¡Acción Realizada!'),
			text: message,
			icon: 'success',
			showCancelButton: true,
			cancelButtonText: t('Cerrar'),
			showCloseButton: true
		})
		.then((result) => {
			if (result.dismiss === swal.DismissReason.cancel) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.close) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.backdrop) {
				swal.close()
			}
		})
}


export const showWarningMessage = (res) => {
	const message =
		typeof res !== 'string'
			? t('Atención: Verifique la información antes de continuar.')
			: res

	swal
		.fire({
			title: t('¡Advertencia!'),
			text: message,
			icon: 'warning',
			showCancelButton: true,
			cancelButtonText: t('Cerrar'),
			showCloseButton: true
		})
		.then((result) => {
			if (
				result.dismiss === swal.DismissReason.cancel ||
				result.dismiss === swal.DismissReason.close ||
				result.dismiss === swal.DismissReason.backdrop
			) {
				swal.close()
			}
		})
}